export const layoutOptions = ['default', 'card', 'media', 'detail', 'block']
